import { render, staticRenderFns } from "./Register-Candidate.vue?vue&type=template&id=9cfd83ae&scoped=true&"
import script from "./Register-Candidate.vue?vue&type=script&lang=js&"
export * from "./Register-Candidate.vue?vue&type=script&lang=js&"
import style0 from "./Register-Candidate.vue?vue&type=style&index=0&id=9cfd83ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfd83ae",
  null
  
)

export default component.exports